<div
  class="container-fluid tw-bg-gradient-to-b tw-from-[#1a1a2e] tw-to-[#16213e]  tw-pb-12"
>
  <!-- Encabezado -->
  <div class="tw-max-w-5xl tw-mx-auto tw-px-4">
    <h2
      class="tw-text-center tw-text-4xl md:tw-text-5xl tw-font-montserrat tw-font-bold tw-pt-12 tw-pb-4 tw-leading-tight"
    >
      <span class="tw-text-white">
        CONÉCTATE A
        <span class="tw-text-[#F67011] tw-drop-shadow-md"
          >NUESTRO SERVICIO</span
        >
      </span>
    </h2>

    <div
      class="tw-h-1 tw-bg-gradient-to-r tw-from-transparent tw-via-[#F67011] tw-to-transparent tw-w-3/4 tw-mx-auto tw-my-4"
    ></div>

    <div class="tw-max-w-7xl tw-mx-auto tw-px-4 tw-py-2">
      <div
        class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 lg:tw-grid-cols-3 tw-mt-4"
      >
        <div
          class="tw-flex tw-flex-col tw-h-full md:tw-rounded-l-xl md:tw-overflow-hidden hover:-tw-translate-y-1.5 tw-transition-all tw-duration-500 tw-ease-in-out"
        >
          <div class="tw-flex-1">
            <app-service
              [destacado]="true"
              [buttonText]="'Contáctanos'"
              [icono]="'bi bi-speedometer'"
              [text]="
                'la clave para trabajar remotamente sin problemas, disfrutar de streaming sin interrupciones,  jugar en línea  y mantenerte conectado con quienes más quieres, de manera fluida y sin límites.
'
              "
              [title]="'INTERNET RÁPIDO'"
              [subTitle]="',CONFIABLE, ASEQUIBLE'"
            ></app-service>
          </div>
        </div>

        <div class="tw-flex tw-flex-col tw-h-full hover:-tw-translate-y-1.5 tw-transition-all tw-duration-500 tw-ease-in-out">
          <div class="tw-flex-1">
            <app-service
              [buttonText]="'Suscríbete'"
              [icono]="'bi bi-wifi'"
              [text]="
                'Porque tu tranquilidad es nuestro compromiso y pensando en tu bienestar, no aplicamos cargos adicionales por pagos atrasados y evitamos la acumulación de mensualidades.
'
              "
              [title]="'INTERNET DE ALTA'"
              [subTitle]="'CALIDAD Y SIN COBROS EXTRAS'"
            ></app-service>
          </div>
        </div>

        <div
          class="tw-flex tw-flex-col tw-h-full md:tw-rounded-r-xl md:tw-overflow-hidden hover:-tw-translate-y-1.5 tw-transition-all tw-duration-500 tw-ease-in-out"
        >
          <div class="tw-flex-1">
            <app-service
              [buttonText]="'Únete'"
              [icono]="'bi bi-headset'"
              [text]="
                'El compromiso de nuestro equipo es brindarte soluciones ágiles y eficaces ante cualquier inconveniente y que sigas disfrutando de nuestro servicio al máximo.
'
              "
              [title]="'ATENCIÓN TÉCNICA'"
              [subTitle]="'ESPECIALIZADA EN MENOS DE 24 HORAS'"
            ></app-service>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
